var ur = window.location.href;
if(ur.includes('/product')){
 jQuery(document).ready(function(){

   $('p.rating-count.caption').click(function(){
  window.scrollTo({
    top: document.querySelectorAll('main#MainContent > section')[1].offsetTop,
    behavior: 'smooth'
});
}); 
Element.prototype.appendAfter = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var imgSrcs = ['https://cdn.shopify.com/s/files/1/0772/2090/5243/files/la_shipping-fast.png?v=1727410335',
'https://cdn.shopify.com/s/files/1/0772/2090/5243/files/hugeicons_delivery-return-01.png?v=1727410335',  
'https://cdn.shopify.com/s/files/1/0772/2090/5243/files/hugeicons_shopping-basket-secure-03.png?v=1727410335'
];
var badgeTexts = ["Free Shipping on All Orders",
                  "Fast and Free Returns",
                  "Safe and Secure Checkout"];
var container = document.createElement('div');
container.className = 'simple-badges-outer-container';
var imgContainer = document.createElement('div');
imgContainer.innerHTML = '';
imgContainer.className = 'simple-img-container';
var y = document.querySelectorAll('.product-form__buttons')[0];
if(document.getElementsByClassName('simple-img-container').length == 0){
  container.appendAfter(y);  
  container.appendChild(imgContainer);
  
}
    
for(var i = 0; i < imgSrcs.length; i++){
                    
    var img = document.createElement('div');
    img.innerHTML = '<div class="simple-badge-container"><img src="' + imgSrcs[i] +  '"><span class="badge'+i+'">'+badgeTexts[i]+'</span></div>';
    imgContainer.appendChild(img);
    img.className = "simple-badges-container";
           
    
} 
    if(jQuery('.fh-buyNow').length == 0){
     jQuery('.product-form__submit').eq(0).after(jQuery('<div class="fh-buyNow">Buy Now</div>'));
 }

  jQuery('.fh-buyNow').click(function(){
    var b = 0;
var timerb = setInterval(function(){
  if(jQuery('.shopify-payment-button__more-options').eq(0).length || b > 200) {
	 jQuery('.shopify-payment-button__more-options').eq(0).click();;
     clearInterval(timerb);
  }
b++;
}, 50);
  });

   
}); 


  jQuery(document).ready(function(){
        
      var btnClass = ".product-form__submit";
      var prodTitle = ".product__title h1";
      var prodPrice = "span.price-item.price-item--regular";
    
        
      Element.prototype.appendAfterThis = function(element) {
        element.parentNode.insertBefore(this, element.nextSibling);
    };
    var sticky = document.createElement('div');
    sticky.innerHTML = '<div class="simple-st-container" id="simple-st-containerID"> <div class="simple-st-container__outer"><div class="simple-product-cont"><div class="simple-product-name"><p></p><div class="st-reviews"></div></div></div> <div class="simple-st-container__inner"><div class="simple-st-item_column__button"><div class="simple-product-price"></div><a class="simple-st-item__button" rel="nofollow">Add to Cart</a></div></div></div></div>';
    var y = document.getElementsByTagName('body');
    if(document.getElementsByClassName('simple-st-container').length == 0){
      y[0].appendChild(sticky);
      
      
    jQuery('.simple-product-name p').html(jQuery(prodTitle).eq(0).html());
    
    setTimeout(function(){ 
    jQuery('.simple-product-price').eq(0).html(jQuery(prodPrice).eq(0).html());
    }, 1000);
      
     
    
      
      jQuery('.simple-st-item__button').click(function(){
      //jQuery(btnClass).click()
       window.scrollTo({
    top: document.querySelectorAll('.product__title')[0].offsetTop,
    behavior: 'smooth'
});
      });
      
     
        
    };
    
           
    var mc = window.matchMedia("(min-width: 767px)");
            
            
        var elem = document.getElementById("simple-st-containerID");      
        function slideShow() {
              jQuery('body').addClass('simple-sticky');
        }
                      
         function slideHide() {    
            jQuery('body').removeClass('simple-sticky');
         }
                  
        jQuery(document).scroll(function() {
        var y = jQuery(this).scrollTop();
        if (y > jQuery(btnClass).eq(0).offset().top) {
           slideShow();
                
        } else {
      
            slideHide();
            
        }
    });   
    }); 
  
}


  jQuery(document).ready(function(){

      jQuery('.quickview-btn').click(function(){
  		var q = jQuery(this).closest('.card').eq(0);
        var qv = 0; var timerqv = setInterval(function(){
          if(q.find('.qview-button').length) {
		q.find('.qview-button').eq(0).click();
      clearInterval(timerqv);}if( qv > 200){clearInterval(timerqv);}qv++;}, 50);
        
      }); 
    
});
    
